import { EmptyLayout } from '@/ui-kit/templates/EmptyLayout';

import { useDashboardConfig } from '@/hooks/useDashboardConfig';

import { UserTypeSelection } from '@/features/user/components/CreateUser/UserTypeSelection';
import { useCreateUserContext } from '@/features/user/contexts/CreateUserContext';
import { Layout as CreateUserLayout } from '@/features/user/components/CreateUser/layout/Layout';
import { StepNavigaton } from '@/features/user/components/CreateUser/StepNavigation/StepNavigation';

export const CreateUser = () => {
  const { userType } = useCreateUserContext();

  const dashboardConfig = useDashboardConfig();
  const userCreationTypes = dashboardConfig.settings.users?.creation;

  if (userCreationTypes?.length) {
    return (
      <CreateUserLayout>
        {!userType ? (
          <UserTypeSelection />
        ) : (
          <>{['physical', 'business', 'selfEmployed'].includes(userType) ? <StepNavigaton /> : <></>}</>
        )}
      </CreateUserLayout>
    );
  }

  return <EmptyLayout />;
};
